//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CompanyInfoDrawer from "./modules/CompanyInfoDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: 'CompanyInfoList',
  mixins: [JeecgListMixin],
  components: {
    CompanyInfoDrawer: CompanyInfoDrawer
  },
  data: function data() {
    return {
      pagePath: '/ea/company/info',
      pageTitle: '供应商信息',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'code',
        colName: 'code',
        title: '编号',
        align: 'center'
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '厂商名称',
        align: 'center'
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: '厂商类别',
        align: 'center'
      }, {
        dataIndex: 'contacts',
        colName: 'contacts',
        title: '联系人',
        align: 'center'
      }, {
        dataIndex: 'tel',
        colName: 'tel',
        title: '联系人电话',
        align: 'center'
      }, {
        dataIndex: 'serviceTel',
        colName: 'service_tel',
        title: '售后电话',
        align: 'center'
      }, {
        dataIndex: 'legal',
        colName: 'legal',
        title: '法定代表人',
        align: 'center'
      }, {
        dataIndex: 'addr',
        colName: 'addr',
        title: '注册地址',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.queryParam.status = 1;
  },
  computed: {},
  methods: {}
};